<template>
  <div class="inventory-by-month-chart">
    <apexchart
      type="line"
      height="350"
      :options="chartOptions"
      :series="series"
    ></apexchart>
  </div>
</template>

<script>
import _ from 'lodash'
import moment from 'moment'

export default {
  name: 'InventoryByMonthChart',
  props: {
    data: {
      type: Array,
      required: true,
    },
    inventoryType: {
      type: String,
      default: 'tubes', // 'tubes' or 'sheets'
    },
  },
  computed: {
    chartOptions() {
      return {
        chart: {
          type: 'line',
          height: 350,
          toolbar: {
            show: true,
          },
        },
        stroke: {
          width: 3,
          curve: 'smooth',
        },
        xaxis: {
          categories: this.categories,
        },
        yaxis: {
          title: {
            text: 'Linear Feet',
          },
        },
        colors: ['#3c58e7', '#f54526', '#5c11a2'],
        legend: {
          position: 'top',
        },
        markers: {
          size: 4,
        },
        tooltip: {
          y: {
            formatter: (val) => {
              return val.toFixed(2) + ' ft'
            },
          },
        },
      }
    },
    categories() {
      return _.map(this.data, (d) => {
        return moment().year(d.year).month(d.month - 1).format('MMM YY')
      })
    },
    series() {
      if (this.inventoryType === 'tubes') {
        return [
          {
            name: '2x2 Tubing',
            data: _.map(
              this.data,
              (d) => d.inventory?.tubes?.['2x2'] || 0,
            ),
          },
          {
            name: '2x3 Tubing',
            data: _.map(
              this.data,
              (d) => d.inventory?.tubes?.['2x3'] || 0,
            ),
          },
          {
            name: '2x4 Tubing',
            data: _.map(
              this.data,
              (d) => d.inventory?.tubes?.['2x4'] || 0,
            ),
          },
        ]
      } else {
        return [
          {
            name: 'Roof Sheets',
            data: _.map(
              this.data,
              (d) => d.inventory?.sheets?.roof?.linearFeet || 0,
            ),
          },
          {
            name: 'Siding Sheets',
            data: _.map(
              this.data,
              (d) => d.inventory?.sheets?.siding?.linearFeet || 0,
            ),
          },
          {
            name: 'Vertical Sheets',
            data: _.map(
              this.data,
              (d) => d.inventory?.sheets?.vertical?.linearFeet || 0,
            ),
          },
        ]
      }
    },
  },
}
</script>

<style lang="scss" scoped></style>



